import { createBrowserRouter, RouterProvider } from "react-router-dom";
import "./App.scss";
import ROUTES from "./routes/routes";
import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { RootState, AppDispatch } from "./redux/store";
import { getTranslations } from "./redux/Slices/dictionarySlice";

const router = createBrowserRouter(ROUTES, {
  future: { v7_startTransition: true } as any,
});

function App() {
  const theme = useSelector((state: RootState) => state.theme.mode);
  const dispatch = useDispatch<AppDispatch>();

  // Apply dark mode class on body
  useEffect(() => {
    document.body.classList.toggle("dark", theme === "dark");
  }, [theme]);

  // Load translations
  useEffect(() => {
    dispatch(getTranslations());
  }, [dispatch]);

  return (
    <div className="App">
      <RouterProvider router={router} future={{ v7_startTransition: true }} />
    </div>
  );
}

export default App;
